import React from 'react'
import { storiesOf } from '@storybook/react'

import HelpButton from 'components/HelpButton'

storiesOf('HelpButton', module)
  .add('default', () => (
    <div>
      <div>
        <HelpButton />
      </div>
      <div>
        <HelpButton>Help me!</HelpButton>
      </div>
      <div>
        <HelpButton color="primary">Help me!</HelpButton>
      </div>
    </div>
  ))
